import { PageNotFound } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/not-found'].update({
        staticData: { title: { page: 'Title.NotFound' } },
        component: PageNotFound
    });
};
